import(/* webpackMode: "eager" */ "/app/apps/nivex-frontend/src/app/global-error.tsx");
